var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.user !== null
        ? _c("div", { staticClass: "d-flex flw-row align-items-center mb-4" }, [
            _c(
              "div",
              { staticClass: "btn-group" },
              [
                _c(
                  "TabButton",
                  {
                    attrs: { tab: "list" },
                    model: {
                      value: _vm.tab,
                      callback: function($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("survey.code.mySurveys")))]
                ),
                _vm._v(" "),
                _vm.entryQrCode
                  ? _c(
                      "TabButton",
                      {
                        attrs: { tab: "qr" },
                        model: {
                          value: _vm.tab,
                          callback: function($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("survey.code.tabQr")))]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex-grow-1" }),
            _vm._v(" "),
            _c("i", {
              staticClass: "fa fa-user mr-1",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "mr-2" },
              [
                _vm.isNoMail(_vm.user.email)
                  ? [
                      _vm._v(
                        _vm._s(_vm.user.firstName) +
                          " " +
                          _vm._s(_vm.user.lastName)
                      )
                    ]
                  : [_vm._v(_vm._s(_vm.user.email))]
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn btn-danger", on: { click: _vm.logout } },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("survey.code.logout")) + "\n    "
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "login"
        ? [
            _vm.loading
              ? _c("CenterOnParent", [_c("Spinner")], 1)
              : _c("CodeLogin", { on: { input: _vm.onLogin } })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "list"
        ? [
            _c(
              "div",
              {
                staticClass: "d-flex flex-column flex-md-row align-items-start"
              },
              [
                _vm.codeImageUrl
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "mb-3 mb-md-0 mr-md-4 d-flex justify-content-center align-items-center flex-shrink-0",
                        staticStyle: { "max-width": "640px" }
                      },
                      [
                        _c("img", {
                          staticClass: "img-fluid rounded shadow-sm",
                          attrs: {
                            src: _vm.codeImageUrl,
                            alt: "Visitor Management"
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-100 flex-grow-1" },
                  [
                    _vm.user
                      ? _c("h4", { staticClass: "mb-3" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.getWelcome()) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "alert alert-info d-flex align-items-center mb-4",
                        attrs: { role: "alert" }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-info-circle mr-2",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(" "),
                        _c("div", [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("survey.code.myInstruction")))
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.getFormattedInstructions())
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$te("survey.code.infoBelowInstruction")
                      ? _c("div", { staticClass: "mb-3" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t("survey.code.infoBelowInstruction"))
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("VueGoodTable", {
                      attrs: {
                        isLoading: _vm.loading,
                        columns: _vm.columnsConfig,
                        rows: _vm.surveysMeta,
                        "pagination-options": _vm.paginationOptions,
                        "search-options": _vm.searchOptions
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "emptystate",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("txtSearchNoRows")) +
                                    "\n          "
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "table-row",
                            fn: function(props) {
                              return [
                                props.column.isSurveyNameColumn
                                  ? _c(
                                      "div",
                                      { staticClass: "d-flex flex-row" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              props.formattedRow[
                                                props.column.field
                                              ]
                                            ) +
                                            "\n              "
                                        ),
                                        _c("AttachmentsButtonIfPresent", {
                                          staticClass: "ml-auto",
                                          attrs: {
                                            surveyId: props.row.surveyId
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : props.column.field === "actions"
                                  ? [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-sm btn-primary",
                                          on: {
                                            click: function($event) {
                                              return _vm.openSurvey(props.row)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-arrow-right"
                                          })
                                        ]
                                      )
                                    ]
                                  : props.column.field === "passed"
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            "badge",
                                            props.row.passed
                                              ? "badge-success"
                                              : "badge-danger"
                                          ]
                                        },
                                        [
                                          _c("i", {
                                            class: [
                                              "fa",
                                              props.row.passed
                                                ? "fa-check"
                                                : "fa-times",
                                              "mr-1"
                                            ]
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  props.row.passed
                                                    ? "yes"
                                                    : "no"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  : _c("span", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            props.formattedRow[
                                              props.column.field
                                            ]
                                          ) +
                                          "\n            "
                                      )
                                    ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2140133350
                      )
                    })
                  ],
                  1
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("StillValidConfirmModal", {
        ref: "stillValidConfirmModal",
        on: {
          confirm: function($event) {
            return _vm.openSurvey($event, true)
          }
        }
      }),
      _vm._v(" "),
      _vm.tab === "qr"
        ? _c(
            "div",
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("survey.code.qrCodeForScanning")) +
                  "\n    "
              ),
              _c("QrCode", { attrs: { content: _vm.entryQrCode } })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "survey"
        ? _c("SurveyJSComponent", {
            attrs: {
              surveyId: _vm.surveyComponentProps.surveyId,
              started: _vm.surveyComponentProps.started,
              user: _vm.surveyComponentProps.user,
              completeScreenBackButtonAction: _vm.onSurveyBack
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }